var map = {
	"./g1.jpeg": 9869,
	"./g10.jpeg": 3619,
	"./g2.jpeg": 268,
	"./g3.jpeg": 5571,
	"./g4.jpeg": 9714,
	"./g5.jpeg": 1289,
	"./g6.jpeg": 2728,
	"./g7.jpeg": 6863,
	"./g8.jpeg": 4046,
	"./g9.jpeg": 6533,
	"./gala-past.jpeg": 6041,
	"./ghana.jpeg": 9700
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6855;